import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { loading } from 'owa-locstrings/lib/strings/loading.locstring.json';
import { ClientItem } from 'owa-mail-store';
import yammerDeeplinkStore from 'owa-yammer-deeplink/lib/store/store';
import { OpxYammerCard } from 'owa-yammer-thread';
import * as React from 'react';
import {
    getStore as getPopoutChildStore,
    PopoutLoadingView,
    PopoutChildState,
} from 'owa-popout-v2';

const styles = require('owa-mail-module-view/lib/components/MailModule.scss');

const DeepLinkYammerView = observer(() => {
    const { deeplinkThreadId } = yammerDeeplinkStore;
    const clientItem = { YammerThreadId: deeplinkThreadId } as ClientItem;
    const { state } = getPopoutChildStore();
    return state != PopoutChildState.Ready ? (
        <PopoutLoadingView loadingString={loc(loading)} />
    ) : (
        <div className={styles.rightPane}>
            <div className={styles.readingPane}>
                <OpxYammerCard
                    viewState={{
                        item: clientItem,
                    }}
                />
            </div>
        </div>
    );
});

export default DeepLinkYammerView;
